import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { GridFilterInputValueProps, GridSingleSelectColDef, useGridApiContext } from '@mui/x-data-grid-pro';

// Changing a filter's column keeps the value the previous column left behind, so its shape need not match this column's arity.
type FilterOption = string | number;

const valueForArity = (value: unknown, isMultiSelect: boolean): FilterOption | FilterOption[] | null => {
  if (isMultiSelect) {
    if (Array.isArray(value)) {
      return value as FilterOption[];
    }
    return value == null || value === '' ? [] : [value as FilterOption];
  }
  return ((Array.isArray(value) ? value[0] : value) as FilterOption) ?? null;
};

export const AutoCompleteFilter = (props: GridFilterInputValueProps) => {
  const { applyValue, item } = props;
  const MULTI_SELECT_FIELDS = ['tags'];
  const apiRef = useGridApiContext();
  const { valueOptions = [] } = apiRef.current.getColumn(item.field) as GridSingleSelectColDef;
  const isMultiSelect = MULTI_SELECT_FIELDS.includes(item.field);

  return (
    <Autocomplete
      id="autocomplete"
      options={valueOptions as FilterOption[]}
      getOptionLabel={String}
      value={valueForArity(item.value, isMultiSelect)}
      sx={{ marginTop: 'auto', width: '15rem' }}
      multiple={isMultiSelect}
      blurOnSelect={!isMultiSelect}
      renderInput={(params) => (
        <TextField
          {...params}
          label="select value"
        />
      )}
      size="small"
      onChange={(event, newValue) => {
        applyValue({ ...item, value: newValue });
      }}
    />
  );
};
